import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-17192 Побудить оверквотников купить подписку / Web / 1 этап
export const overquotaBlockDate: boolean | undefined = getFeature('overquota-block-date');
